export default __webpack_public_path__ + "static/media/aira_1.7be3d7de.PNG";